import { Component, Host, h, Prop } from "@stencil/core";

@Component({
    tag: "c-form-datepicker",
    styleUrl: "c-form-datepicker.scss",
})
export class CFormDatepicker {
    @Prop() formTitle?: string;
    @Prop() germanTitle?: string;

    render() {
        return (
            <Host class="">
                <label
                    htmlFor="c-auswahl-date"
                    class="label-text"
                    data-german={this.germanTitle}
                    innerHTML={this.formTitle}
                ></label>
                <input
                    id="c-auswahl-date"
                    type="date"
                    title={this.germanTitle || this.formTitle}
                    data-german={this.germanTitle}
                    aria-label={this.formTitle || "Datum auswählen"}
                    aria-controls="cb-conversation"
                    autocomplete="off"
                />
            </Host>
        );
    }
}